import * as Sentry from '@sentry/nextjs'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const fetcher = async (url: string): Promise<any> => {
  fetch(url).then((res) => res.json())
  const res = await fetch(url)

  if (!res.ok) {
    const error = {
      error: new Error('An error occurred while fetching the data.'),
      info: await res.json(),
      status: res.status,
    }
    Sentry.captureException({
      error,
      action: 'get traning program',
      isTtransitionCompleteTo500page: false,
    })
  }

  return res.json()
}
